import {useHistory} from "react-router-dom";

const useActiveMenuItem = (link, exact = false) => {
  const history = useHistory()
  const currentLocation = history.location.pathname;
  return  exact ? currentLocation === link : currentLocation.startsWith(link);
};

export default useActiveMenuItem;
